import React from 'react';
import { func } from 'prop-types';
import { FlexContainer, IconContainer, Icon, Row, Text, Button } from '..';

const DrawerError = ({ onCancel }) => (
    <FlexContainer margin={30} align='center' direction='column'>
        <IconContainer color='#f38630'>
            <Icon name='trash' color='#ffffff' size={46.8} />
        </IconContainer>
        <FlexContainer mY={30} direction='column' align='center'>
            <Row justify='center'>
                <Text text='Se ha producido un error. Intente nuevamente.' />
            </Row>
        </FlexContainer>
        <FlexContainer justify='flex-end' style={{ width: '100%' }}>
            <Button
                text='Cerrar'
                style={{ width: '100px' }}
                onClick={() => onCancel()}
            />
        </FlexContainer>
    </FlexContainer>
);

DrawerError.propTypes = {
    onCancel: func
};

DrawerError.defaultProps = {
    onCancel: () => {}
};

export default DrawerError;
